

let isAutoScrolling = false;
let animationFrame = null;

// Smooth scroll that tracks the dynamic logo size
function scrollPastLogoSmooth() {
  const logoWrapper = document.querySelector('.header__custom-logo-wrapper');
  if (!logoWrapper) return;

  // If another auto-scroll is running, cancel it
  if (animationFrame) {
    cancelAnimationFrame(animationFrame);
    animationFrame = null;
  }

  isAutoScrolling = true;

  function step() {
    const logoRect = logoWrapper.getBoundingClientRect();
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Dynamic target: bottom of the logo relative to the viewport
    const target = currentScroll + logoRect.bottom;

    // Distance to scroll
    const distance = target - currentScroll;

    // Slow down the motion: adjust factor (0.15 = slower, 0.3 = faster)
    const stepAmount = distance * 0.1;

    if (Math.abs(distance) > 1) {
      window.scrollBy(0, stepAmount);
      animationFrame = requestAnimationFrame(step);
    } else {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
      isAutoScrolling = false; // Reset flag when done
    }
  }

  animationFrame = requestAnimationFrame(step);
}

// Retry until logo exists
function retryScroll(attempts = 10, delay = 50) {
  if (attempts <= 0) return;

  const logoWrapper = document.querySelector('.header__custom-logo-wrapper');
  if (logoWrapper) {
    scrollPastLogoSmooth();
  } else {
    setTimeout(() => retryScroll(attempts - 1, delay), delay);
  }
}

// Handle internal link clicks
function handleLinkClicks() {
  document.querySelectorAll('a[href^="/"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const targetUrl = new URL(link.href, window.location.origin);
      const currentUrl = window.location;

      if (targetUrl.pathname === currentUrl.pathname) {
        // Same page → scroll immediately
        e.preventDefault();
        history.pushState({}, '', link.href);
        retryScroll();
      } else {
        // Different page → scroll after load
        localStorage.setItem('skipHeader', 'true');
      }
    });
  });
}

// Handle scroll on page load
function handleSkipHeaderOnLoad() {
  if (localStorage.getItem('skipHeader')) {
    retryScroll();
    localStorage.removeItem('skipHeader');
  }
}

// Stop auto-scrolling immediately if the user interacts
window.addEventListener('wheel', () => {
  if (isAutoScrolling) {
    cancelAnimationFrame(animationFrame);
    animationFrame = null;
    isAutoScrolling = false;
  }
});
window.addEventListener('touchstart', () => {
  if (isAutoScrolling) {
    cancelAnimationFrame(animationFrame);
    animationFrame = null;
    isAutoScrolling = false;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  handleLinkClicks();
  handleSkipHeaderOnLoad();
});

document.addEventListener('turbo:load', handleSkipHeaderOnLoad);
document.addEventListener('shopify:section:load', handleSkipHeaderOnLoad);


